import React, { Component } from 'react';
import MainLayout from '../../components/layouts/main';
import Constants from '../../data/constants';

class LayoutPage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <MainLayout id={Constants.LAYOUT_PAGE}>
                Layout Page
            </MainLayout>
        );
    }
}

export default LayoutPage;